// Configuration
var signedurlinstant = "";
const appState = {
    current: {
        signType: "bladesign",
        size: "small",
        backgroundIndex: 0
    },
    uploaded: {
        logo: null
    },
    flags: {
        userUploadedBackground: false,
        instantResultLoaded: false,
        bulkResultLoaded: false
    }
};
 config = {
    signTypes: {
         bladesign: {
            label: 'Bladesign',
            pruducturl: '',
            processedurl: '',
            basePrices: {},
            previews: [],
            thumbs: [
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/mockup-design-1.jpg?v=1751607442",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/mockup-design-2.jpg?v=1751607556",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/mockup-design.jpg?v=1751607602",
            ]
        },
        acrylic_lightbox: {
            label: 'Lightbox',
            pruducturl: '',
            processedurl: '',
            basePrices: {},
            previews: [],
            thumbs: [
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/acrylic1.png?v=1747391967",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/acrylic2.png?v=1747391967",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/acrylic3.png?v=1747391967",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/acrylic4.png?v=1747391967"
            ]
        },
        metal_sign: {
            label: 'Flat Cut Metal Sign',
            pruducturl: '',
            processedurl: '',
            basePrices: {},
            previews: [],
            thumbs: [
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/metal1.png?v=1747392318",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/metal3_ce97f831-094e-455e-848c-9208e4059b2d.png?v=1747659622",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/metal3.png?v=1747392318",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/metal4.png?v=1747392318"
            ]
        },
        acrylic_backlit: {
            label: '3D Acrylic Backlit',
            pruducturl: '',
            processedurl: '',
            basePrices: {},
            previews: [],
            thumbs: [
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/backlit1.png?v=1747392400",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/backlit2_1eee243d-595b-421e-a340-32dd36c79d47.png?v=1747726938",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/backlit3.png?v=1747392400",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/backlit4.png?v=1747392400"
            ]
        }
    },
    loadingMessages: [
        "Analyzing your logo for optimal display...",
        "Preparing premium material previews for your brand...",
        "Configuring 3D visualization settings...",
        "Setting up lighting and shadow effects...",
        "Optimizing your design for different sign types...",
        "Almost ready to transform your brand into stunning signage!"
    ]
};


 const mockupApiURL = 'https://designs.quicksignage.com'; 
   var productURL;
//------------------------------------


async function submitForm() {
    try {
        const imageFile = document.getElementById("file-input").files[0];
        const clientEmail = document.getElementById("customer-email").value;

    //     if (!imageFile) {
    // alert("Please upload a logo image.");
    // resetFormUI();   // 👈 pehli jagah wapas
    // return false;
    // }
    // console.log('sss: '+imageFile.type);


        const formData = new FormData();
        formData.append("image", imageFile);
        formData.append("logo", imageFile);
        formData.append("name", "clientName");
        formData.append("email", clientEmail);
        formData.append("template", 1);

        hideInitialUploadUI();
        disableOtherSignTabs();
        simulateUploadProgress();

        // 1. Show Blade Sign (Instant)
        const instantRes = await fetch(`${mockupApiURL}/api/webhook/image/generator/signage`, {
            method: "POST",
            headers:{
                //"Content-Type":"application/json",
                "Accept":"application/json"
            },
            body: formData
        });

        if (!instantRes.ok) throw new Error("Instant preview failed.");
        const instantData = await instantRes.json();
        displayBladeSignInstant(instantData.images);
        signedurlinstant = instantData.signed_url;
        console.log(signedurlinstant);
        // const dynamicPrices = bladeSignData.price || {}
        console.log(instantData.images.bladesign.price);
      // store instant data to localstorage
        localStorage.setItem('instantPreview', JSON.stringify(instantData));
        // console.log(instantData);

        // 2. Start Bulk Process
        const bulkRes = await fetch(`${mockupApiURL}/api/webhook/generate/mockup/job/bulk`, {
            method: "POST",
            body: formData
        });

        if (!bulkRes.ok) throw new Error("Failed to start bulk job.");
        const bulkData = await bulkRes.json();
        if (!bulkData.has_queued) return;

        // 3. Wait for Bulk
        pollForBulkCompletion(bulkData.template);

    } catch (error) {
        console.error("Error:", error);
    }
}
//reset when file type not matched to our image extention

//  Disable sign type buttons (except bladesign) until bulk results are in
function disableSignButtonsDuringBulk() {
    const tabs = document.querySelectorAll("#sign-type-tabs .nav-link");
    tabs.forEach(button => {
        const type = button.getAttribute("data-type");
        if (type !== "bladesign") {
            const originalText = button.textContent.trim();
            button.dataset.originalText = originalText;

            button.innerHTML = `<span class="loading-label">${originalText} <span class="dot-loader">.</span></span>`;
            button.classList.add("blurred");
            button.disabled = true;
            button.style.opacity = "0.5";
            button.style.pointerEvents = "none";
        }
    });

    startDotLoader();
}

function enableSignButtonsAfterBulk() {
    stopDotLoader();

    const tabs = document.querySelectorAll("#sign-type-tabs .nav-link");
    tabs.forEach(button => {
        const type = button.getAttribute("data-type");
        if (type && type !== "bladesign") {
            const originalText = button.dataset.originalText || button.textContent.trim();
            button.textContent = originalText;
            button.classList.remove("blurred");
            button.disabled = false;
            button.style.opacity = "1";
            button.style.pointerEvents = "auto";
        }
    });
}
// async function handleImageUpload(imageFile, clientEmail) {
//     try {
//         const formData = new FormData();
//         formData.append("image", imageFile);
//         formData.append("logo", imageFile);
//         formData.append("email", clientEmail);
//         formData.append("name", "clientName");
//         formData.append("template", 1);

//         disableSignButtonsDuringBulk();

//         // Step 1: Show instant preview (blade sign)
//         const instantResponse = await fetch("https://designs.quicksignage.com/api/webhook/image/generator/signage", {
//             method: "POST",
//             body: formData
//         });
//         const instantResult = await instantResponse.json();

//         if (instantResult?.images?.length > 0) {
//             appState.flags.instantResultLoaded = true;
//             config.signTypes.bladesign.previews = [];
//             config.signTypes.bladesign.thumbs = [];
            
//             instantResult.images.forEach((img, index) => {
//                 config.signTypes.bladesign.previews.push(img.url);
//                 config.signTypes.bladesign.thumbs.push(img.url);
//             });
          
//             appState.current.signType = "bladesign";
//             updateStudioView();
//         }

//         // Step 2: Fire bulk generation
//         const bulkResponse = await fetch("https://designs.quicksignage.com/api/webhook/generate/mockup/job/bulk/signage", {
//             method: "POST",
//             body: formData
//         });

//         const bulkResult = await bulkResponse.json();
//         if (!bulkResult.has_queued) return;

//         // Step 3: Poll bulk job status
//         let tries = 0;
//         const maxTries = 15;
//         const pollingUrl = `https://designs.quicksignage.com/api/webhook/generate/mockup/job/bulk/status/${bulkResult.template}/signage`;

//         while (tries < maxTries) {
//             await new Promise(resolve => setTimeout(resolve, 10000)); // 10s delay
//             const statusRes = await fetch(pollingUrl);
//             const statusData = await statusRes.json();

//             //if (statusData.records) {
//                 //appState.flags.bulkResultLoaded = true;
//                 updateConfigFromBulk(statusData.records);
//                 console.log("=================keys===================");
//                 enableSignButtonsAfterBulk(statusData.records);
//                 break;
//             //}

//             tries++;
//         }
//     } catch (err) {
//         console.error("Image processing failed", err);
//     }
// }

//  Update config object based on bulk API
function updateConfigFromBulk(records) {
    for (const key in records) {
        const data = records[key];
        console.log("=================keys===================");
        //console.log(data);
        
        const targetKey = mapBulkKeyToConfigKey(key);

        if (!targetKey || !config.signTypes[targetKey]) continue;

        config.signTypes[targetKey].previews = [...data.images];
        config.signTypes[targetKey].thumbs = [...data.images];
        config.signTypes[targetKey].pruducturl = data.signed;
        config.signTypes[targetKey].processedurl = data.processed_url;

        config.signTypes[targetKey].basePrices = {};
        for (const [size, price] of Object.entries(data.prices)) {
            config.signTypes[targetKey].basePrices[size.toLowerCase()] = price;
        }
    }

    // Refresh UI
    updateStudioView();
}

//  Map API key name to our config keys
function mapBulkKeyToConfigKey(apiKey) {
    switch (apiKey) {
        case "acrylic_lightbox": return "acrylic_lightbox";
        case "3d_metal_sign": return "metal_sign";
        case "3d_acrylic_backlit": return "acrylic_backlit";
        default: return null;
    }
}
function updateStudioView() {
    updateMainPreview();
    updateBackgroundThumbnails();
    updatePricingPanel();
}

function updateMainPreview() {
    const current = config.signTypes[appState.current.signType];
    const imageUrl = current.previews[appState.current.backgroundIndex];
    document.getElementById("main-preview-img").src = imageUrl;
}

function updateBackgroundThumbnails() {
    const container = document.getElementById("background-thumbnails");
    const current = config.signTypes[appState.current.signType];

    container.innerHTML = '<h5 class="mb-3">Background Options</h5>';
    current.thumbs.forEach((img, index) => {
        const thumb = document.createElement("div");
        thumb.className = `v-buttons mb-3 ${index === appState.current.backgroundIndex ? "active" : ""}`;
        thumb.innerHTML = `<img src="${img}" class="img-fluid rounded" style="width: 100%; aspect-ratio: 16/9; object-fit: cover">`;
        thumb.addEventListener("click", () => {
            appState.current.backgroundIndex = index;
            updateStudioView();
        });
        container.appendChild(thumb);
    });
}
function startDotLoader() {
    const loaderSpans = document.querySelectorAll(".dot-loader");
    let dotCount = 1;

    dotLoaderInterval = setInterval(() => {
        dotCount = (dotCount % 3) + 1;
        loaderSpans.forEach(span => {
            span.textContent = '.'.repeat(dotCount);
        });
    }, 500);
}

function stopDotLoader() {
    clearInterval(dotLoaderInterval);
}
function updatePricingPanel() {
    const current = config.signTypes[appState.current.signType];
    document.getElementById("pricing-title").textContent = current.label;
    document.querySelectorAll(".size-options .v-buttons").forEach(el => {
        const size = el.dataset.size;
        const price = current.basePrices[size];
        const priceEl = el.querySelector(".v-price");
        if (priceEl) priceEl.textContent = `$${price}`;
    });
}
function hideInitialUploadUI() {
    const tpheading = document.getElementById("tp-heading");
    const alreadycreated = document.getElementById("already");
    const tpalready = document.getElementById("tp-already");
    const demomocsliders = document.getElementById("demomocsliders");

    tpheading?.classList.add("d-none");
    alreadycreated?.classList.add("d-none");
    tpalready?.classList.add("d-none");
    demomocsliders && (demomocsliders.style.display = "none");
}

function disableOtherSignTabs() {
    const tabs = document.querySelectorAll("#sign-type-tabs .nav-link");
    tabs.forEach(tab => {
        const type = tab.getAttribute("data-type");
        if (type && type !== "bladesign") {
            tab.classList.add("blurred-tab");
            tab.style.pointerEvents = "none";
            tab.style.opacity = "0.5";
        }
    });
    // const loaders = document.querySelectorAll(".cs-loader");
    // loaders.forEach(loader => {
    //     loader.style.display = "block";
    // });
  // Disable the "Order Now" button
    const orderBtn = document.getElementById("ordernow");
    if (orderBtn) {
        orderBtn.disabled = true;
        orderBtn.style.opacity = "0.3";
        orderBtn.style.cursor = "not-allowed";
    }
}

function enableSignTabsFromBulk(records) {
    Object.keys(records).forEach(type => {
      console.log(type);
        const btn = document.querySelector(`#sign-type-tabs button[data-signtype="${type}"]`);
        if (btn) {
            btn.classList.remove("blurred-tab");
            btn.style.pointerEvents = "auto";
            btn.style.opacity = "1";
            console.log(`✅ Tab enabled: ${type}`);
        }else {
            console.warn(`⚠️ Tab not found for type: ${type}`);
        }
    });
  const orderBtn = document.getElementById("ordernow");
    if (orderBtn) {
        orderBtn.disabled = false;
        orderBtn.style.opacity = "1";
        orderBtn.style.cursor = "pointer";
    }
}

function displayBladeSignInstant(images) {
    const urls = Object.values(images).map(item => item.url);
    
    config.signTypes.bladesign = {
        label: "Blade Sign",
        pruducturl: "",
        processedurl: "",
        previews: urls,
        thumbs: [
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/mockup-design-1.jpg?v=1751607442",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/mockup-design-2.jpg?v=1751607556",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/mockup-design.jpg?v=1751607602",
                  "https://cdn.shopify.com/s/files/1/0732/5374/8956/files/mock-5.jpg?v=1756461244",
            ],
        // basePrices: {
        //     small: images[0]?.price || 400,
        //     medium: images[1]?.price || 710,
        //     large: images[2]?.price || 890
        // }
        basePrices: {
            small: 530,
            medium: 820,
            large: 1080
        }
    };

    state.currentSignType = "bladesign";
    updatefrontend();
}

async function pollForBulkCompletion(templateId) {
    let retries = 0;
    const maxRetries = 15;
    const delay = 15000;

    while (retries < maxRetries) {
        await new Promise(resolve => setTimeout(resolve, delay));
        retries++;

        try {
            const statusRes = await fetch(`${mockupApiURL}/api/webhook/generate/mockup/job/bulk/status/${templateId}/signage`);
            if (!statusRes.ok) continue;

            const jobResult = await statusRes.json();
            
            if(jobResult.records){
               localStorage.setItem("jobRecords", JSON.stringify(jobResult.records));
                setconfig(jobResult.records);
                enableSignTabsFromBulk(jobResult.records);
                updatefrontend();
            }
            if (jobResult.remaining === 0) {
                break;
            }
        } catch (error) {
            console.warn("Bulk polling error:", error.message);
        }
    }
}

function simulateUploadProgress() {
    let progress = 0;
    const interval = 40000 / 100;
    const progressInterval = setInterval(() => {
        progress += 1;
        updateProgress(progress);
        if (progress >= 100) clearInterval(progressInterval);
    }, interval);
}

function updateProgress(progress) {
    elements.progressBar.style.width = `${progress}%`;
    const messageIndex = Math.min(Math.floor(progress / 100 * config.loadingMessages.length), config.loadingMessages.length - 1);
    elements.processingMessage.textContent = config.loadingMessages[messageIndex];
    elements.progressStatus.textContent = progress < 100
        ? "Please wait while we prepare your customization experience..."
        : "Studio ready! Let's create your perfect signage.";
}


//----------------------------for localstorage --------
  
      document.addEventListener('DOMContentLoaded', function () {
          const urlParams = new URLSearchParams(window.location.search);
          let alreadycreated = document.getElementById('already');
          const JobRecord = localStorage.getItem('jobRecords');
          const bladesignsdata = localStorage.getItem('instantPreview');
            let tpalready = document.getElementById('tp-already');
          if (urlParams.has('already_has')) {
            const initialUploadD = document.querySelector('#initial-upload');
            // let tpheading = document.getElementById('tp-heading');
           console.log("blade data--------------");
            console.log(bladesignsdata);
            // let tpalready = document.getElementById('tp-already');
            
            let demomocslidersElement = document.getElementById('demomocsliders');
            if (bladesignsdata) {
                let parsedRecords = JSON.parse(bladesignsdata);
                const simplified = parsedRecords.images;
                const previews = Object.values(simplified).map(item => item.url);
                signedurlinstant = parsedRecords.signed_url;
                config.signTypes.bladesign = {
                    label: "Blade Sign",
                    pruducturl: "",
                    processedurl: "",
                    previews: previews,
                    thumbs: [
                        "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/mockup-design-1.jpg?v=1751607442",
                        "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/mockup-design-2.jpg?v=1751607556",
                        "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/mockup-design.jpg?v=1751607602",
                        "https://cdn.shopify.com/s/files/1/0732/5374/8956/files/mock-5.jpg?v=1756461244",
                    ],
                    // basePrices: {
                    //     small: simplified["acrylic-lightbox"]?.price.small || 1000,
                    //     medium: simplified["metalbacklit"]?.price.medium || 1200,
                    //     large: simplified["metalsign"]?.price.large || 1400
                    // }
                  basePrices: {
                      small: 530,
                      medium: 820,
                      large: 1080
                  }
                };
                // const previewImgElement = document.getElementById('main-preview-img');
                //     if (previewImgElement) {
                //         previewImgElement.src = firstImage;
                //     }
            }
            if (JobRecord) {
                initialUploadD.classList.add('d-none');
                let parsedRecords = JSON.parse(JobRecord);
                setconfig(parsedRecords);
                initializeStudio();
                updatefrontend();
                // if (tpheading) {
                //   tpheading.classList.add('d-none');
                // }
                if (alreadycreated) {
                  alreadycreated.classList.add('d-none');
                }
              if (demomocslidersElement) {
                  demomocslidersElement.classList.add('d-none');
                }
              if (tpalready) {
                  tpalready.classList.add('d-none');
                }
                // // Set main-preview-img source to first preview image
                // const firstKey = Object.keys(parsedRecords)[1];
                // if (parsedRecords[firstKey] && parsedRecords[firstKey].images && parsedRecords[firstKey].images.length > 0) {
                //     const firstImage = parsedRecords[firstKey].images[0];
                  
                //   console.log(firstImage);
                //     const previewImgElement = document.getElementById('main-preview-img');
                //     if (previewImgElement) {
                //         previewImgElement.src = firstImage;
                //     }
                // }
      
            }else {
              if (alreadycreated) alreadycreated.classList.add('d-none','bbb');
            }
          }
          
          if (!JobRecord) {
            if (alreadycreated) alreadycreated.classList.add('d-none','bbb');
          }
          
          // force click on bladesign
          setTimeout(() => {
              const bladeSignButton = document.querySelector('[data-type="bladesign"]');
              if (bladeSignButton) {
                console.log('----------------------------bladesign btn------------------------')
                  console.log(bladeSignButton);
                  bladeSignButton.click();
              }
          }, 300);
          
      });



function setconfig(records) {
  var cnt = 0;

  for (const key in records) {
    cnt++;
    if (records.hasOwnProperty(key)) {
      const data = records[key];

      if (Array.isArray(data.images)) {
        data.images.forEach((imgUrl, index) => {
          if (key == 'acrylic_lightbox') {
            config.signTypes.acrylic_lightbox.previews.push(imgUrl);
            if (data.prices && typeof data.prices === "object") {
              Object.entries(data.prices).forEach(([size, price]) => {
                config.signTypes.acrylic_lightbox.basePrices[size.toLowerCase()] = price;
              });
            }
            config.signTypes.acrylic_lightbox.pruducturl = data.signed;
            config.signTypes.acrylic_lightbox.processedurl = data.processed_url;
          }

          if (key == '3d_metal_sign') {
            config.signTypes.metal_sign.previews.push(imgUrl);
            if (data.prices && typeof data.prices === "object") {
              Object.entries(data.prices).forEach(([size, price]) => {
                config.signTypes.metal_sign.basePrices[size.toLowerCase()] = price;
              });
            }
            config.signTypes.metal_sign.pruducturl = data.signed;
            config.signTypes.metal_sign.processedurl = data.processed_url;
          }

          if (key == '3d_acrylic_backlit') {
            config.signTypes.acrylic_backlit.previews.push(imgUrl);
            if (data.prices && typeof data.prices === "object") {
              Object.entries(data.prices).forEach(([size, price]) => {
                config.signTypes.acrylic_backlit.basePrices[size.toLowerCase()] = price;
              });
            }
            config.signTypes.acrylic_backlit.pruducturl = data.signed;
            config.signTypes.acrylic_backlit.processedurl = data.processed_url;
          }
        });
      }
    }
  }

  updateStudioView();
}



// State management
const state = {
    currentSignType: 'acrylic_lightbox',
    currentSize: 'small',
    selectedBackground: 0,
    uploadedLogo: null
};

// DOM Elements
const elements = {
    uploadZone: document.getElementById('upload-zone'),
    fileInput: document.getElementById('file-input'),
    resizebox: document.getElementById('resize-box'),
    draggableimg: document.getElementById('logo-draggable'),
    filebg: document.getElementById('file-bg'),
    userbg: document.getElementById('userbg'),
    filebgthumb: document.getElementById('userbgthumb'), 
    initialUpload: document.getElementById('initial-upload'),
    processingIndicator: document.getElementById('processing-indicator'),
    studioContainer: document.getElementById('studio-container'),
    mainPreviewImg: document.getElementById('main-preview-img'),
    previewTypeLabel: document.getElementById('preview-type-label'),
    backgroundThumbnails: document.getElementById('background-thumbnails'),
    pricingTitle: document.getElementById('pricing-title'),
    progressBar: document.querySelector('.progress-bar'),
    processingMessage: document.getElementById('processing-message'),
    progressStatus: document.getElementById('progress-status')
};

  // Event Listeners
  document.addEventListener('DOMContentLoaded', () => {
      setupUploadHandlers();
      setupSignTypeTabs();
      setupSizeOptions();
      initializeStudio();
  });
  // for file bg
  elements.filebg.addEventListener('click', function () {
    // Reset the input value to allow same file selection
    elements.filebg.value = '';
  });
  //---------------------------
var useruploadedbg = 0;
  elements.filebg.addEventListener('change', function(event) {
  const file = event.target.files[0];
  const allthumbs = document.querySelectorAll('#background-thumbnails .v-buttons');
  allthumbs.forEach(b => b.classList.remove('active'));
  processedImageDisplay(true);   
          
  if (file && file.type.startsWith('image/')) {
    const reader = new FileReader();
    reader.onload = function(e) {
      //console.log("======"+e.target.result);
      elements.mainPreviewImg.src = e.target.result;
      //document.getElementById('userbgthumb').src = e.target.result;
      elements.draggableimg.src = e.target.result;
        if(useruploadedbg===0){
          useruploadedbg=1;
          config.signTypes.acrylic_lightbox.thumbs.unshift(e.target.result);
          config.signTypes.metal_sign.thumbs.unshift(e.target.result);
          config.signTypes.acrylic_backlit.thumbs.unshift(e.target.result);
          config.signTypes.acrylic_lightbox.previews.unshift(e.target.result);
          config.signTypes.metal_sign.previews.unshift(e.target.result);
          config.signTypes.acrylic_backlit.previews.unshift(e.target.result);
        } else {
          config.signTypes.acrylic_lightbox.thumbs[0] = e.target.result;
          config.signTypes.metal_sign.thumbs[0] = e.target.result;
          config.signTypes.acrylic_backlit.thumbs[0] = e.target.result;
          config.signTypes.acrylic_lightbox.previews[0] = e.target.result;
          config.signTypes.metal_sign.previews[0] = e.target.result;
          config.signTypes.acrylic_backlit.previews[0] = e.target.result;
        }
      state.selectedBackground = 0;
      updateBackgroundThumbnails();
      updatedragableimg();
    };
    reader.readAsDataURL(file);
  } else {
    alert("Please select a valid image file.");
  }
});
// Upload Handlers
function setupUploadHandlers() {
    elements.uploadZone.addEventListener('click', () => elements.fileInput.click());
    elements.fileInput.addEventListener('change', handleFileSelect);

    elements.uploadZone.addEventListener('dragover', (e) => {
        if (!validateForm()) {
            e.preventDefault(); // stop file from being dragged in
            elements.uploadZone.classList.remove('drag-active');
            return;
        }

        e.preventDefault();
        elements.uploadZone.classList.add('drag-active');
    });

    elements.uploadZone.addEventListener('dragleave', () => {
        elements.uploadZone.classList.remove('drag-active');
    });

    elements.uploadZone.addEventListener('drop', (e) => {
        if (!validateForm()) {
            e.preventDefault();
            elements.uploadZone.classList.remove('drag-active');
            return;
        }

        e.preventDefault();
        elements.uploadZone.classList.remove('drag-active');

        const file = e.dataTransfer.files[0];
        if (file) {
            // Assign dragged file to file input
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            document.getElementById('file-input').files = dataTransfer.files;

            // Call your upload handler
            handleFileUpload(file);
        }
    });
}

function handleFileSelect(e) {
    const file = e.target.files[0];
    if (file) handleFileUpload(file);
}
function validateForm() {
    const clientEmail = document.getElementById("customer-email").value.trim();
    const clientEmailInput = document.getElementById("customer-email");
    const emailErrorSpan = document.getElementById("customeremail");
    let isValid = true;

    if (!clientEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(clientEmail)) {
        clientEmailInput.style.borderColor = "red";
        emailErrorSpan.textContent = "Error: Valid email is required";
        isValid = false;
    }
    else {
        clientEmailInput.style.borderColor = "";
        emailErrorSpan.textContent = "";
    }

    return isValid;
}

function validateEmailFormat(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
// function validateform(){
//     const clientName = document.getElementById('customer-name').value.trim();
//     const clientEmail = document.getElementById('customer-email').value.trim();
//     const errorSpan = document.getElementById('customername');
//     const errorSpan = document.getElementById('customeremail');
//   if (!clientName) {
//         errorSpan.textContent = 'Please enter your name first.';
//         return false;
//     } else {
//         errorSpan.textContent = '';  // clear error if any
//     }
//   if (!clientEmail) {
//         errorSpan.textContent = 'Please enter your email first.';
//         return false;
//     } else {
//         errorSpan.textContent = '';  // clear error if any
//     }
// }
function handleFileUpload(file) {

        const MAX_SIZE_MB = 7.8; // 7.8 MB  max file size in MB 5624358
        const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp","image/bmp", "image/x-ms-bmp"];

        console.log("File size: "+file.size);

    if (!file.type.match('image.*')) {
        alert('Please upload an image file');
        return;
    }
    if (!ALLOWED_TYPES.includes(file.type)) {
        alert("Invalid logo file type. Allowed: JPG, JPEG, PNG, WEBP, BMP.");
        return; 
    }

    if ((file.size/(1024 * 1024)) > MAX_SIZE_MB) {
        alert(`Logo must be smaller than ${MAX_SIZE_MB} MB.`);
        return;
    }





    state.uploadedLogo = file;
    showProcessingIndicator();
    //simulateUploadProgress();
}

// Processing Simulation
function showProcessingIndicator() {

    if(submitForm() == false){
        elements.initialUpload.classList.remove('d-none');
        elements.processingIndicator.classList.add('d-none');
        return; 
    } 
    else {
    elements.initialUpload.classList.add('d-none');
    elements.processingIndicator.classList.remove('d-none');
    }

}

function simulateUploadProgress() {
    let progress = 0;
    const totalTime = 40000; // 10 seconds
    const steps = 100;
    const interval = totalTime / steps;
    
    const progressInterval = setInterval(() => {
        progress += 1;
        updateProgress(progress);        
        // if (progress >= 100) {
          // clearInterval(progressInterval);
        // }
    }, interval);
}

function updatefrontend(){            
      setTimeout(() => {
          elements.processingIndicator.classList.add('d-none');
          elements.studioContainer.classList.remove('d-none');
          updateStudioView();
      }, 500); 
}
function updateProgress(progress) {
    elements.progressBar.style.width = `${progress}%`;
    
    // Update loading message based on progress
    const messageIndex = Math.min(
        Math.floor((progress / 100) * config.loadingMessages.length),
        config.loadingMessages.length - 1
    );
    elements.processingMessage.textContent = config.loadingMessages[messageIndex];
    
    elements.progressStatus.textContent = progress < 100 ? 
        'Please wait while we prepare your customization experience...' : 
        'Studio ready! Let\'s create your perfect signage.';
}

// Studio Initialization and Updates
function initializeStudio() {
    updateMainPreview();
    updateBackgroundThumbnails();
    updatePricingPanel();
}
function processedImageDisplay(display){
  
  if(display){
    document.getElementById('resize-box').classList.remove('d-none');  
  }
  else{
    document.getElementById('resize-box').classList.add('d-none');  
  }
}

function setupSignTypeTabs() {
    const tabs = document.querySelectorAll('#sign-type-tabs .nav-link');
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
            state.currentSignType = tab.dataset.type;
          
            processedImageDisplay(false);
            state.selectedBackground = 0;
            updateStudioView();
            if(useruploadedbg==1){
              updatedragableimg();
            }
        });
    });
}
// blade sign blure bg image btn
    document.addEventListener('DOMContentLoaded', () => {
        const label = document.querySelector('.uploadbgh');
        const resizeBox = document.getElementById('resize-box');
      
        function checkBlur() {
          const btn = document.querySelector('.nav-link.active');
          const isBlade = btn?.dataset.type === 'bladesign';
      
          label.classList.toggle('blade-blure', isBlade);
          resizeBox.style.display = isBlade ? 'none' : '';
        }
      
        document.querySelectorAll('.nav-link').forEach(btn =>
          btn.addEventListener('click', () => setTimeout(checkBlur, 10))
        );
      
        checkBlur(); // on page load/back
      });



function updatedragableimg(){
    const currentType = config.signTypes[state.currentSignType];
    elements.draggableimg.src = currentType.processedurl;
    elements.resizebox.classList.remove('d-none');  
}

function setupSizeOptions() {
    const sizeButtons = document.querySelectorAll('.size-options .v-buttons');
    sizeButtons.forEach(button => {
        button.addEventListener('click', () => {
            sizeButtons.forEach(b => b.classList.remove('active'));
            button.classList.add('active');
            state.currentSize = button.dataset.size;
            updatePricingPanel();
        });
    });
}

function updateStudioView() {
    updateMainPreview();
    updateBackgroundThumbnails();
    updatePricingPanel();
}

function updateMainPreview() {
  if(useruploadedbg==0){
    elements.resizebox.classList.add('d-none');
    // console.log('user image uploaded: '+useruploadedbg);
    processedImageDisplay(false);
  }
    const currentType = config.signTypes[state.currentSignType];
    elements.mainPreviewImg.src = currentType.previews[state.selectedBackground];
  console.log(elements.mainPreviewImg.src)
    // elements.previewTypeLabel.textContent = currentType.label;
}

function updateBackgroundThumbnails() {
    const currentType = config.signTypes[state.currentSignType];
    elements.backgroundThumbnails.innerHTML = '<h5 class="mb-3">Background Options</h5>';
    elements.resizebox.classList.add('d-none');
  
    currentType.thumbs.forEach((preview, index) => {
        const thumbnail = document.createElement('div');
        thumbnail.className = `v-buttons mb-3 ${index === state.selectedBackground ? 'active' : ''} ${useruploadedbg==1 ? 'imgbyux' : ''}`;
        thumbnail.innerHTML = `
            <img src="${preview}" 
                alt="Background option ${index + 1}" 
                class="img-fluid rounded"
                style="width: 100%; aspect-ratio: 16/9; object-fit: cover">`;
        thumbnail.addEventListener('click', () => {
            state.selectedBackground = index;
            updateStudioView();            
            if(index==0 && useruploadedbg==1){
              processedImageDisplay(true);
            } else {
              processedImageDisplay(false);
            }
        });
        elements.backgroundThumbnails.appendChild(thumbnail);
    });
}

function updatePricingPanel() {
    const currentType = config.signTypes[state.currentSignType];
    elements.pricingTitle.textContent = currentType.label;
    
    const priceElements = document.querySelectorAll('.size-options .v-buttons');
    priceElements.forEach(element => {
        const size = element.dataset.size;
        const priceElement = element.querySelector('.v-price');
        priceElement.textContent = `$${currentType.basePrices[size]}`;
    });
}


async function buyNow() {
    const createLoader = document.getElementById("creating-loader");
    toggleLoader(createLoader, true);

    try {
        // Get selected variant size
        const activeButton = document.querySelector('.size-options .v-buttons.active');
        if (!activeButton) throw new Error("No active variant selected!");
        const selectedSize = activeButton.getAttribute('data-size');

        const activeTab = document.querySelector('.nav-link.active');
        const signType = activeTab?.getAttribute('data-type');
  
        let productData;

        if (signType === "bladesign") {
            // Blade Sign: call alternate API
            
            const imageUrl = document.querySelector('#main-preview-img').src;
            const price = document.querySelector('.v-buttons.active .v-price').textContent; 
            const title = "Blade Sign "+document.querySelector('.v-buttons.active .font-medium').textContent; 
            const response = await fetch(signedurlinstant, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ url: imageUrl, price, title })
            });
              
            productData = await response.json();
            console.log("Product data for blade:", productData.cart_url);
            var cart_url = productData.cart_url;  
            location.href = cart_url;
        } else {
            const currentType = config.signTypes[state.currentSignType];
            const productURL = currentType.pruducturl;
            console.log(productURL)
            productData = await fetchProductData(productURL);
        }

        if (!productData?.variants?.length) throw new Error("No product variants found!");

        // Match variant by size
        const selectedVariant = productData.variants.find(variant =>
            variant.size.toLowerCase() === selectedSize.toLowerCase()
        );

        if (!selectedVariant) throw new Error("Selected variant ID not found!");

        const redirectUrl = `https://signage.com/cart/clear?return_to=/cart/add?items[0][id]=${selectedVariant.id}%26items[0][quantity]=1%26return_to=/checkout?discount=QS10OFF`;
         location.href = redirectUrl;

    } catch (error) {
        console.error("Something went wrong! Please try again.", error.message);
    } finally {
        toggleLoader(createLoader, false);
    }
}

  
  function toggleLoader(loader, isVisible) {
      loader.style.display = isVisible ? "block" : "none";
  }
  
  async function fetchProductData(url) {
      try {
          const response = await fetch(url);
          const result = await response.json();
          console.log("Full API Response:", result);
  
          if (result.status !== "success") {
              throw new Error("API did not return a success status!");
          }
  
          return result;
      } catch (error) {
          throw new Error("Failed to fetch product data: " + error.message);
      }
  }

